export const drugAndAlcoholTesting = () => {
  return [
    { text: `     15. DRUG AND ALCOHOL TESTING`, bold: true, style: 'p' },

    {
      text: [
        { text: `     15.1.`, bold: true },
        { text: ` As a motor carrier, Independent Contractor recognizes that Independent Contractor’s business of providing the transportation Services hereunder involves the use of motor vehicles provided by Independent Contractor, and as such, Independent Contractor is involved in a safety sensitive business that puts the public at risk. Independent Contractor agrees that the safety of the public outweighs any right to privacy by Independent Contractor and/or Independent Contractor’s employees, agents or subcontractors. To minimize the safety risk posed by Independent Contractor’s operation of motor vehicles, Independent Contractor agrees to enroll in an approved Drug Consortium for purposes of complying with this Section 15. As part of such Drug Consortium, Independent Contractor shall agree that Company shall be provided with a certificate of enrollment, and that Independent Contractor shall monitor such consent and authorization so that Company is notified (the "Notification") of any violation and of a failure to comply with the provisions in this Section 15. Independent Contractor acknowledges that Company will ask Independent Contractor and/or Independent Contractor’s employees or subcontractors to undergo a drug and/or alcohol test under the following circumstances:` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     15.1.1.`, bold: true },
        { text: ` prior to the performance of any services for Company under this TICA;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     15.1.2.`, bold: true },
        { text: ` whenever the Company or its Customer has a reasonable suspicion that the actions, appearance or conduct of Independent Contractor or Independent Contractor’s employees or subcontractors, while performing services for the Customer, are indicative of the use of a controlled substance and/or alcohol test;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     15.1.3.`, bold: true },
        { text: ` whenever Independent Contractor or any of Independent Contractor’s employees or subcontractors are involved in an accident or involved in an unsafe practice that requires medical care, involves injury to others, or property damage;` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     15.1.4.`, bold: true },
        { text: ` upon the request of Company’s Customer, clean drug tests on a periodic basis, with or without notice; and,` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     15.1.5.`, bold: true },
        { text: ` as required by law.` }
      ],
      style: 'p',
      margin: [40, 0, 0, 10],
    },

    {
      text: [
        { text: `     15.2.`, bold: true },
        { text: ` Except as otherwise required by law or regulation, Independent Contractor understands that, as an Independent Contractor, Independent Contractor can refuse to undergo a drug and/or alcohol test at any time. Independent Contractor also acknowledges that the Company cannot force Independent Contractor’s own employees or subcontractors to undergo a drug and/or alcohol test. However, Independent Contractor can and does conduct such drug and/or alcohol tests as to its own employees. Accordingly, Independent Contractor will not permit either itself and/or any employee to operate a vehicle owned by Independent Contractor who has not certified to do so or who is impaired at the time of operating said vehicle.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     15.3.`, bold: true },
        { text: ` To the extent consistent with applicable law, Independent Contractor authorizes a testing laboratory, and its physician(s) and/or technician(s), to conduct a urinalysis or breath analysis, to withdraw a specimen(s) of Independent Contractor’s blood, and/or to remove a sample of Independent Contractor’s hair for the purpose of chemical analysis to determine the drug and/or alcohol content thereof. Independent Contractor further consents to the release by the testing laboratory of the results of this analysis to the Company or any Customer who has retained the Independent Contractor’s services.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     15.4.`, bold: true },
        { text: ` Notwithstanding any provision to the Contrary, Independent Contractor agrees that if, after undergoing a drug and/or alcohol test, it is determined that any of Independent Contractor’s employees or subcontractors were under the influence of illegal drugs, a controlled substance or alcohol while performing services under this TICA, Independent Contractor shall terminate such employee or subcontractor who is under the influence of drugs or alcohol.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     15.5.`, bold: true },
        { text: ` If an Independent Contractor or Independent Contractor’s employee or subcontractor chooses to undergo a drug and/or alcohol test, to the extent consistent with applicable law, the Independent Contractor consents to the release of the drug and/or alcohol results to the Company.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     15.6.`, bold: true },
        { text: ` To the extent consistent with applicable law, Independent Contractor and Independent Contractor’s employees and subcontractors hereby release the Company, its officers, directors, employees, representatives and agents, employees, representatives and agents from any and all claims or causes of action resulting from a drug and/or alcohol test and the release of the information regarding the results.` }
      ],
      style: 'p',
    },

    {
      text: [
        { text: `     15.7.`, bold: true },
        { text: ` Independent Contractor shall be responsible for ensuring that Independent Contractor and any of Independent Contractor’s employees and/or subcontractors performing services hereunder comply with these requirements and shall be responsible for all costs associated with such compliance.` }
      ],
      style: 'p',
    },
  ]
}